import { useDispatch } from "react-redux";
import { profileActions } from "../../../di/di";

export default function ProfileHelpComponent() {
  const dispatch = useDispatch();
  return (
    <div className="w-full px-4 sm:px-0 sm:mx-0 sm:max-w-xl mt-4" style={{ animationDelay: "1.2s" }}>
      <div className="bg-gradient-to-b from-slate-950 to-fuchsia-950/80 rounded-xl p-6 border border-red-900/20 shadow-xl">
        <h2 className="text-2xl font-bold text-center text-pink-200 mb-6">Need help? We're Here For You!</h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <button
            onClick={() => dispatch(profileActions.setShowContactModal(true))}
            className="text-base flex-1 py-3 px-4 bg-slate-900/50 backdrop-blur-sm border border-red-900/20 rounded-md hover:bg-red-900/40 transition-colors active:translate-y-0.5 active:shadow-none"
          >
            Contact Us
          </button>
          <button
            onClick={() => dispatch(profileActions.setShowFeedbackModal(true))}
            className="text-base flex-1 py-3 px-4 bg-slate-900/50 backdrop-blur-sm border border-red-900/20 rounded-md hover:bg-red-900/40 transition-colors active:translate-y-0.5 active:shadow-none"
          >
            Submit Feedback
          </button>
          {/* <button
              onClick={navigateToPrivacyPolicy}
              className="text-base flex-1 py-3 px-4 bg-slate-900/50 backdrop-blur-sm border border-red-900/20 rounded-md hover:bg-slate-800/60 transition-colors hover-scale"
            >
              Privacy Policy
            </button> */}
        </div>
      </div>
    </div>
  );
}
